import React from "react";
import { FcGoogle } from "react-icons/fc";
import { Button } from "@/components/ui/button";

const LOGIN_BG =
  "https://static.prod-images.emergentagent.com/jobs/2607a866-1734-4153-ba40-4a4b2827589f/images/424c4f7704400aa47fe0612901219011c6a8e1ce21813aeaa2038e0cb15f4b39.png";

export default function Login() {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2 bg-[var(--rt-bg)]" data-testid="login-page">
      {/* Visual side */}
      <div className="hidden md:block relative border-r border-[var(--rt-border)]">
        <img
          src={LOGIN_BG}
          alt="Rank tracker"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-white/30" />
        <div className="absolute top-8 left-8">
          <div className="label-eyebrow">[SERP / Rank Intelligence]</div>
          <div className="font-display text-3xl mt-2 leading-none">RankSpine</div>
        </div>
        <div className="absolute bottom-10 left-8 right-10">
          <p className="font-display text-2xl leading-tight">
            Track up to <span className="font-mono-data">30</span> websites &times; <span className="font-mono-data">200</span> keywords.<br/>
            Weekly Google US desktop SERPs. Precise. Auditable.
          </p>
          <p className="text-sm mt-3 text-[var(--rt-text-muted)]">Powered by DataForSEO &middot; Top 100 organic results</p>
        </div>
      </div>

      {/* Form side */}
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="label-eyebrow mb-3">/ access</div>
          <h1 className="font-display text-4xl leading-none mb-4">Sign in</h1>
          <p className="text-sm text-[var(--rt-text-muted)] mb-8 leading-relaxed">
            Use your Google account to access your tracking dashboard.
            Your session lasts 7 days.
          </p>

          <Button
            data-testid="google-login-btn"
            onClick={handleGoogleLogin}
            className="w-full h-12 rounded-none bg-white text-[var(--rt-text)] border border-[var(--rt-border)] hover:bg-[var(--rt-surface-hover)] hover:border-zinc-400 transition-colors duration-150 flex items-center justify-center gap-3"
          >
            <FcGoogle size={20} />
            <span className="font-medium">Continue with Google</span>
          </Button>

          <div className="mt-12 grid grid-cols-3 gap-4 text-xs">
            {[
              { k: "WEBSITES", v: "30" },
              { k: "KEYWORDS / SITE", v: "200" },
              { k: "DEPTH", v: "TOP 100" },
            ].map((it) => (
              <div key={it.k} className="border-t border-[var(--rt-border)] pt-3">
                <div className="label-eyebrow text-[10px]">{it.k}</div>
                <div className="font-display text-2xl mt-1">{it.v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
